export enum ContractTypeDisplayEnum {
	LEASE = 'Lease',
	AMENDMENT = 'Amendment',
	LETTER_AGREEMENT = 'Letter Agreement',
	SUBTENANT_AGREEMENT = 'Subtenant Agreement',
	EASEMENT = 'Easement',
	LICENSE_AGREEMENT = 'License Agreement',
	VALIDATION_AGREEMENT = 'Validation Agreement',
	OTHER = 'Other',
}
